import { Component, OnInit } from "@angular/core";
import { DocumentsService } from "../../../../../auth/service/documents.service";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService } from "../../../../../auth/service";
import moment from "moment";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { ICurrentUser } from "app/auth/models/user-interface";

@Component({
  selector: "app-documents-list",
  templateUrl: "./staff-all-documents-list.component.html",
  styleUrls: ["./staff-all-documents-list.component.scss"],
})
export class StaffAllDocumentsListComponent implements OnInit {
  public config: any;
  public contentHeader: IContentHeader;
  public document: any;
  public tableLimit: number = 10;
  public searchKeyword: string = "";
  public categories: any = [];
  public categoriesTreeView: any = [];
  public selectedCategory: string = "all";
  public searchStatus: number = 10;
  public me: ICurrentUser;
  public tomorrow: any = moment().add(1, "d").format("YYYY-MM-DD");
  public isViewFolder: boolean = false;

  constructor(
    public _documentService: DocumentsService,
    public _utilService: UtilsService,
    private _routerService: Router,
    public _modalService: NgbModal,
    public _authenticationService: AuthenticationService,
    private activatedRoute: ActivatedRoute,
  ) {
    this._utilService.disableAutoHideLoading();
    this.config = {
      selectLimitItems: true,
      headerHeight: 30,
      rowHeight: window.innerWidth > 1440 ? 70 : 100,
      footerHeight: 60,
      scrollbarH: true,
    };

    this.contentHeader = {
      headerTitle: "MENU.DOCUMENTS_LIST",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.MANAGE",
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: "MENU.DOCUMENTS_LIST",
            isLink: false,
          },
        ],
      },
    };

    this.activatedRoute.queryParams.subscribe((params: any) => {
      this.searchKeyword = !!params.search ? params.search : "";

      if (!!params.ref) {
        if (!!params.search) {
          this.contentHeader.breadcrumb.links[1] = {
            name: "MENU.USERS",
            isLink: true,
            link: "/dashboard/user/list/employee",
          };
          this.contentHeader.breadcrumb.links[2] = {
            name: this.searchKeyword,
            isLink: true,
            link: params.ref,
          };
          this.contentHeader.breadcrumb.links[3] = {
            name: "DOCUMENTS_AREA",
            isLink: false,
          };

          this.contentHeader.headerTitle = "DOCUMENTS_AREA";
        } else if (!params.search && !!params.refTitle) {
          this.contentHeader.breadcrumb.links[1] = {
            name: params.refTitle,
            isLink: true,
            link: params.ref,
          };
        }
      }
    });
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_menu_documents_list")) {
      await this._routerService.navigateByUrl("/dashboard/main");
      this._utilService.hideLoading();
      return false;
    }
    //Check if in the local storage there is a preference for the document view
    let isDocumentViewInLocalStorage = localStorage.getItem("documentFolderView");
    if (isDocumentViewInLocalStorage) {
      this.isViewFolder = isDocumentViewInLocalStorage == "true";
    }

    this.categories = await this._documentService.getCategoriesList().then((categories: any) => {
      const orderedListCategories: any = [];
      categories.map((cat: any) => {
        // push del padre
        orderedListCategories.push(cat);
        if (cat.child) {
          cat.child.map((child: any) => {
            child.children = [];
            orderedListCategories.push(child);
          });
        }
      });
      return orderedListCategories;
    });

    this.categoriesTreeView = this.categories.filter((item) => !item.parent_id);
    this.categoriesTreeView.map((item: any) => {
      item.showChild = false;
      if (item.child) {
        item.child.map((child: any) => {
          child.showFile = false;
        });
      }
    });

    await this.loadDocuments();
    this.me = await this._authenticationService.getCurrentUser();
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  async loadDocuments() {
    this.document = await this._documentService.getList();
    const approved: string = await this._utilService.translate("APPROVED_FEMALE_SINGULAR");
    const pending: string = await this._utilService.translate("PENDING");
    const notApproved: string = await this._utilService.translate("NOT_APPROVED_SINGULAR");
    const deleted: string = await this._utilService.translate("ABORTED");
    this.document.map((item: any) => {
      item.user_data.map((data: any) => {
        //Array di nomi utenti per filtrarli al meglio in caso di queryParam
        if (data.complete_name && data.complete_name.length > 0) {
          item.user_complete_name = [];
          item.user_complete_name.push(data.complete_name.toLowerCase());
        }
      });
      if (item.status === 1) {
        item.enabled_label = approved;
      } else if (item.status === 2) {
        item.enabled_label = notApproved;
      } else if (item.status === 3) {
        item.enabled_label = deleted;
      } else {
        item.enabled_label = pending;
      }
    });
    setTimeout(() => this._utilService.hideLoading());
  }

  documentList() {
    let items: any = this.document;
    if (!items) {
      return [];
    }

    const keywords: string = this.searchKeyword.trim().toLowerCase();

    if (keywords.length > 0) {
      items = items.filter((item: any) => item.title?.toLowerCase().includes(keywords) || item.user_complete_name?.includes(keywords));
    }

    if (this.selectedCategory !== "all") {
      items = items.filter((item: any) => item.category_name?.toLowerCase() === this.selectedCategory.toLowerCase());
    }

    return items;
  }

  changeView() {
    this.isViewFolder = !this.isViewFolder;
    localStorage.setItem("documentFolderView", String(this.isViewFolder)); //Set the preference in localStorage
    if (this.isViewFolder) {
      //Reset the variable for the datatable
      this.searchKeyword = "";
      this.selectedCategory = "all";
      this.tableLimit = 10;
    } else {
      //Reset the variable for the tree view folder
      this.categoriesTreeView.map((cat) => {
        cat.showChild = false;
        if (cat.child) {
          cat.child.map((child) => {
            child.showFile = false;
          });
        }
      });
    }
  }

  //Function for the parent folders
  showChildCategory(item: any) {
    //Boolean condition for the categories parent
    item.showChild = !item.showChild;
    //The other category parent and children will not display check on id for not close the selected one
    this.categoriesTreeView.map((cat) => {
      if (cat.id !== item.id) {
        cat.showChild = false;
      }
      if (cat.child) {
        cat.child.map((child) => {
          if (child.parent_id !== item.id) {
            child.showFile = false;
          }
        });
      } else {
        //If it doesn't have child folders, it's mean is a parent with files inside and not folders
        //Filter document with the same category
        item.fileList = this.document.filter((doc) => doc.category_name === item.name);
        if (item.fileList && item.fileList.length < 1) {
          //If there aren't files we will show a message as a title
          this._utilService.translate("NOT_FILES_FOUNDED").then((errorMessage: string) => {
            item.fileList.push({ title: errorMessage, haveNotChild: true });
          });
        }
      }
    });
  }

  //Function for the children folders inside a parent folder
  showFileListOfCategory(item: any) {
    //Boolean condition for the categories children
    item.showFile = !item.showFile;
    //The other categories parent and children will not display check on id for not close the selected one
    this.categoriesTreeView.map((cat) => {
      if (cat.id !== item.parent_id) {
        cat.showChild = false;
      }
      if (cat.child) {
        cat.child.map((child) => {
          if (child.id !== item.id) {
            child.showFile = false;
          }
        });
      }
    });
    //Filter document with the same category
    item.fileList = this.document.filter((doc) => doc.category_name === item.name);
    if (item.fileList && item.fileList.length < 1) {
      //If there aren't files we will show a message as a title
      this._utilService.translate("NOT_FILES_FOUNDED").then((error_message: string) => {
        item.fileList.push({ title: error_message, haveNotChild: true });
      });
    }
  }

  async goToDocument(item: any) {
    item.user_data = item.user_data.filter((user: any) => user.hash);
    //If it doesn't have users we will open the file directly in a new tab
    if ((!item.user_data || item.user_data.length < 1) && item.description) {
      await this._utilService.getFile(item.description);
    } else {
      //If the document has recipients we will open the document staff-view
      await this._routerService.navigateByUrl(`/dashboard/document-staff-view/${item.id}`);
    }
  }

  async deleteDocument(currentDocument) {
    if (!this._authenticationService.hasCapability("delete_document")) {
      window.history.back();
      return false;
    }
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += currentDocument.title;
    if (currentDocument) {
      await this._utilService.showSWALDeleteConfirmation({ text: deleteText }).then(async (result) => {
        if (result.value) {
          await this._documentService
            .delete(currentDocument.id)
            .then(async () => {
              await this._utilService.showPopupItemDeleted().then(async () => {
                await this.loadDocuments();
              });
            })
            .catch(() => this._utilService.showSWALError({ text: "ERROR_DOCUMENT_REMOVE" }));
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      });
    }
    await this.loadDocuments();
  }
}
